import listView from '@/data/gift/view/list.vue'
import editorView from '@/data/gift/view/editor.vue'

const list = {
  path: '/gift',
  name: 'gift-list',
  component: listView
}

const creator = {
  path: '/gift/editor/:id(\\d+)',
  name: 'gift-editor',
  component: editorView
}

const editor = {
  path: '/gift/editor/:id(\\d+)',
  name: 'gift-editor',
  component: editorView
}

export default [list, creator, editor]
